import styled from 'styled-components/native';

export const ImageBackground = styled.ImageBackground.attrs({
  resizeMode: 'cover',
})`
  flex: 1;
`;
